/**
 * Single source of truth for the portal's nav-aligned content column.
 *
 * The top navigation header is the alignment anchor for the page. Everything meant to
 * line up under it — the onboarding banner, the sticky category bar, the search + results
 * count, and the property card grid — shares this exact wrapper so they can never drift.
 * Change the column width here and the nav and all aligned content move together.
 *
 * One global width for the whole portal: `max-w-7xl` with responsive gutters, matching
 * PortalContainer's default so every surface — header, onboarding banner, invest, and the
 * Settings/reading pages (which render inside PortalContainer) — lines up at the same edges.
 */
export const CONTENT_WIDTH = 'max-w-7xl mx-auto px-4 sm:px-6';
